export var modalRestrictedUser = () => {
  $('.gitb-modal-restricted-user-open').click(() =>
      window.modalWindow = $('#restricted-user.itcs-modal').dialog({
        dialogClass: "gitb-register-modal",
        height: "auto",
        width: 400,
        modal: true,
        show: {effect: 'clip', speed: 'fast'},
        resizable: false,
        draggable: false,
//      closeText: 'hide',
        open(event, ui) {
          $('.ui-widget-overlay').on('click', () => window.modalWindow.dialog('close'));
        }
      })
  );
};
